<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/logo-teman-bakat.png" height="90px" alt="" />
      </section>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/iam/Misi2-3-3Judul.png"
          height="90px"
          alt=""
        />
      </section>
      <section class="mb-2 d-flex justify-center">
        <img
          v-if="result.hasil_rentang == 'Thinking'"
          src="../../assets/img/iam/Misi2-2-1Ilustrasi Thinking.png"
          height="230px"
          alt=""
        />
        <img
          v-if="result.hasil_rentang == 'Feeling'"
          src="../../assets/img/iam/Misi2-2-1Ilustrasi Feeling.png"
          height="250px"
          alt=""
        />
        <img
          v-if="result.hasil_rentang == 'Thinking-Feeling'"
          src="../../assets/img/iam/Misi2-2-1Ilustrasi Thinking-Feeling.png"
          height="250px"
          alt=""
        />
      </section>
      <div class="temp-pyramid">
        <div class="type">
          <p class="ma-0 white--text">
            <strong>Kamu Cenderung {{ result.hasil_rentang }}</strong>
          </p>
        </div>
      </div>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/iam/Misi2-3-4Isi Personality.png"
          height="60px"
          alt=""
        />
      </section>
      <section class="pa-3">
        <p class="purple--text">
          <strong>Deskripsi :</strong>
        </p>
        <v-card class="pa-3 mb-2">
          <p>{{ result.desc_rentang }}</p>
        </v-card>
      </section>
    </div>
    <uiDownload />
  </div>
</template>

<script>
import uiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { uiDownload },
  name: "resultIam",
  data() {
    return {
      result: "",
      pyramid: {},
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let data = JSON.parse(localStorage.getItem("teskarakter"));
    this.result = JSON.parse(data.result);
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.type {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
</style>
